export default "__VITE_ASSET__BYTvb8Tk__"